// src/components/compliance/ObligationUploadCard.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx.
import FileDropzone from "../../shared/ui/FileDropzone";
import { MAX_FILE_SIZE } from "../../utils/compliance/constants";

export default function ObligationUploadCard({ onSubmit }) {
  return (
    <FileDropzone
      theme="legacy"
      accept={[".docx", ".pdf"]}
      maxTotalSize={MAX_FILE_SIZE}
      title="Upload SOW document"
      description={
        <>
          Accepted formats: <strong>.docx</strong> or <strong>.pdf</strong>.
          The AI will extract every contractual, legal, regulatory and security
          obligation from the SOW.
        </>
      }
      submitLabel="Extract Obligations"
      submittingLabel="Uploading…"
      onSubmit={onSubmit}
    />
  );
}
